<template>
    <div class="container">
        <div class="paramForm">
            <el-form :model="params" label-width="90px" class="approveForm">
                <el-row>
                    <!-- <el-form-item label="账户类型">
                        <el-select v-model="params.type" placeholder="账户类型" disabled>
                            <el-option v-for="item in assetsTypeOptions" clearable :key="item.code" :label="item.name" :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="币种">
                        <el-input v-model="params.currency" clearable></el-input>
                    </el-form-item>
                     -->
                    <el-form-item label="会员地址">
                        <el-input v-model="params.memberAddress" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="变更原因">
                        <el-select v-model="params.reason" clearable>
                            <el-option v-for="item in reasonOptions" clearable :key="item.code" :label="item.name" :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
            </el-form>
            <div class="paramFormButton">
                <el-button type="primary" icon="el-icon-search" @click="handleCurrentChange(1)">搜索</el-button>
            </div>
        </div>
        <div class="tableTool">
            <el-button type="primary" icon="el-icon-printer" @click="exportExcel">导出</el-button>
        </div>
        <el-table border :data="tableData">
            <el-table-column prop="id" align="center" label="ID" width="80"></el-table-column>
            <!-- <el-table-column prop="type" label="账户类型" align="center" width="100">
                <template slot-scope="scope">{{ assetsTypeMap[scope.row.type] }}</template>
            </el-table-column> -->
            <!-- <el-table-column prop="memberId" label="会员UID" align="center" width="80"></el-table-column> -->
            <el-table-column align="center" label="会员地址" width="150" class-name="address">
                <template slot-scope="scope" v-if="scope.row.memberAddress">
                    <span  v-clipboard:copy="scope.row.memberAddress" v-clipboard:success="onCopy">
                        {{showAddress(scope.row.memberAddress)}}<i class="el-icon-document-copy"/>
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="currency" label="币种" align="center" width="100"></el-table-column>
            <!-- <el-table-column prop="direction" label="加/减" align="center" width="100"></el-table-column> -->
            <el-table-column prop="amount" label="数量" align="center" width="200">
                <template slot-scope="scope">{{scope.row.direction=="ADD"?"+":"-"}} {{scope.row.amount}}</template>
            </el-table-column>
            <el-table-column prop="reason" label="变化原因" align="center">
                <template slot-scope="scope">{{ reasonMap[scope.row.reason] }}</template>
            </el-table-column>
            <!--
            <el-table-column prop="direction" label="加/减" align="center" width="100"></el-table-column>
            <el-table-column prop="totalBalance" align="center" label="总资产(前/后)">
                <template slot-scope="scope">{{ scope.row.oldTotalBalance + ' / ' + scope.row.newTotalBalance }}</template>
            </el-table-column>
            <el-table-column align="center" label="可用资产(前/后)">
                <template slot-scope="scope">{{
                    scope.row.oldTotalBalance - scope.row.oldFrozenBalance +' / ' + (scope.row.newTotalBalance - scope.row.newFrozenBalance)
                }}</template>
            </el-table-column>
            <el-table-column prop="frozenBalance" align="center" label="冻结(前/后)">
                <template slot-scope="scope">{{ scope.row.oldFrozenBalance + ' / ' + scope.row.newFrozenBalance }}</template>
            </el-table-column>
            <el-table-column prop="createdBy" label="来源UID" align="center" width="80"></el-table-column>
            <el-table-column prop="comments" label="备注" align="center" width="200"  show-overflow-tooltip></el-table-column>
            -->
            <el-table-column prop="createdAt" label="更新时间" align="center" width="150"></el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                background
                layout="total,sizes, prev, pager, next"
                :current-page="pageInfo.pageNum"
                :page-size="pageInfo.pageSize"
                :page-sizes="[10, 20, 50, 100, 200]"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import { assetsApi } from '@/api/api-assets';
import { exportData1,exportData2 } from '@/assets/js/exportExcel';
export default {
    data() {
        return {
            pageInfo: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            total: 0,
            params: {},
        };
    },
    created() {
        this.reasonOptions = this.findDict("ASSET_REASON");
        this.reasonMap = this.listToMap(this.reasonOptions,"code","name");
        this.handleSearch();
    },
    methods: {
        onCopy() {
            this.$message.success({message: "复制成功",duration: 600})
        },
        handleSearch() {
            assetsApi.findLogPageList(this.params, this.pageInfo).then(res => {
                this.tableData = res.records;
                this.total = res.total || 0;
            });
        },
        handleSizeChange(val) {
            this.pageInfo.pageSize = val;
            this.handleSearch();
        },
        handleCurrentChange(val) {
            this.pageInfo.pageNum = val;
            this.handleSearch();
        },
        exportExcel() {
            if(!this.tableData || this.tableData.length==0){
                this.$message.warning({message: "没有可导出的数据",duration: 600})
                return;
            }
            let header = ['ID', '会员地址', '币种', '数量', '变化原因', '更新时间'];
            let columns = ['id', 'memberAddress', 'currency', 'amount', 'reason', 'createdAt'];
            let data = this.tableData.map(r => columns.map(c => {
                let val = r[c];
                if(c == 'reason'){
                    return this.reasonMap[val];
                }else if(c == 'amount'){
                    if(r['direction'] == 'ADD'){
                        return "+"+val;
                    }else{
                        return "-"+val;
                    }
                }else{
                    return val;
                }   
            }));
            exportData2(header,data,"资产日志记录");
        }
    }
};
</script>
